import {connect} from 'react-redux';
import Squads from './Squads.jsx';

import {
  hideSquadDialog
} from './actionTypes';

import {
  handleEventClick,
  handleDayClick,
  moveToPreviousMonth,
  moveToNextMonth
} from './actions';

const mapStateToProps = state => state.tournament.squads;

const mapDispatchToProps = dispatch => ({
  onEventClick: (target, eventData, day) => dispatch(handleEventClick(target, eventData, day)),
  onModalCloseClick: () => dispatch(hideSquadDialog()),
  onDayClick: (target, day) => dispatch(handleDayClick(target, day)),
  onPreviousClick: () => dispatch(moveToPreviousMonth()),
  onNextClick: () => dispatch(moveToNextMonth())
});

export default connect(mapStateToProps, mapDispatchToProps)(Squads);



// WEBPACK FOOTER //
// ./src/features/tournament/squads/SquadsContainer.jsx